// The conversation in the platform agent's panel. Wording from the Amigo design's copy sheet; `steps` labels the
// step list (keys in platformAgentConversation.js). The working line's labels are docs/platform-agent/contracts.md
// §5's table, in services/platform-agent/stepLabels.js.
export default {
  conversation: 'Conversation',
  working: 'Working on it…',
  stopped: 'Stopped. Nothing changed.',
  step_stopped: 'Stopped',
  not_sent: 'Not sent',
  failed: {
    text: 'Something went wrong on my side, so nothing changed. Try again in a moment.',
    retry: 'Try again',
  },
  question: {
    type_answer: 'Or type your answer below.',
  },
  unavailable: {
    title: {
      amigo: "Amigo isn't available right now.",
      assistant: "The assistant isn't available right now.",
    },
    text: 'Nothing has changed, and the rest of the dashboard works as normal. Try again in a few minutes.',
  },
  // A chat that goes on over several days (D4): a line before each day's first message, and Today to carry on.
  today: 'Today',
  when: {
    today: 'Today, {{time}}',
    yesterday: 'Yesterday, {{time}}',
    date: '{{date}}, {{time}}',
  },
  new_chat_line: "New chat for {{restaurant}}. {{previous}}'s chats are under Chats when you go back to it.",
  // Someone else's chat, opened by our team (D4): whose it is, by who started it (contracts §6 `started_by.kind`).
  read_only: {
    whose: {
      foodamigos: "{{name}}'s chat (FoodAmigos)",
      owner: "{{name}}'s chat (owner)",
      staff: "{{name}}'s chat (staff)",
      partner: "{{name}}'s chat (partner)",
      other: "{{name}}'s chat",
      unnamed: "Someone else's chat",
    },
    text: "{{name}}'s chat. You can read it, but not reply or approve its cards.",
    text_unnamed: "Someone else's chat. You can read it, but not reply or approve its cards.",
    new_chat: 'New chat',
  },
  // A chat whose eve session can't go on (QA42): read only, and New chat takes the message that didn't go with it.
  ended: {
    text: 'This chat has ended. Start a new chat to go on.',
    new_chat: 'New chat',
    moved_line: 'New chat, because the last one had ended',
  },
  composer: {
    label: 'Message',
    placeholder: 'Ask a question, or describe a change',
    placeholder_answer: 'Type your answer',
    hint: 'Enter to send · Shift+Enter new line',
  },
  table: {
    show_all: 'Show all {{count}} rows',
    show_fewer: 'Show fewer',
  },
  steps: {
    areas: 'Checking what I can help with here',
    area_describe: 'Looking at {{area}}',
    read: 'Reading your data',
    propose: 'Preparing the change',
    change_set_get: 'Checking the change',
    gap_record: 'Noting this for our team',
    research: 'Looking up how this works',
    screen_find: 'Finding the right page',
    file_read: 'Reading your file',
    shop_check: 'Checking your shop',
    area_describe_other: 'Looking at this area',
    other: 'Checking something',
  },
  // What a step that failed says it couldn't do (QL46), by the area it worked in; `other` is the label without an
  // area. contracts §5's Failed steps, kept the same as STEP_FAILED_LABELS in stepLabels.js (a test holds en and de).
  failed_steps: {
    read: {
      menu: "Couldn't read the menu",
      hours: "Couldn't read the opening hours",
      order_settings: "Couldn't read the order settings",
      my_info: "Couldn't read your details",
      marketing: "Couldn't read your marketing",
      gift_cards: "Couldn't read the gift cards",
      reports: "Couldn't read your numbers",
      other: "Couldn't read your data",
    },
    propose: {
      menu: "Couldn't prepare the menu change",
      hours: "Couldn't prepare the opening hours change",
      order_settings: "Couldn't prepare the order settings change",
      my_info: "Couldn't prepare the change to your details",
      marketing: "Couldn't prepare the marketing change",
      gift_cards: "Couldn't prepare the gift card change",
      other: "Couldn't prepare the change",
    },
    change_set_get: { other: "Couldn't check the change" },
    research: { other: "Couldn't look up how this works" },
    screen_find: { other: "Couldn't find the page" },
    file_read: { other: "Couldn't read your file" },
    shop_check: { other: "Couldn't open your shop" },
  },
  // The areas of contracts §0 as the steps name them ("Looking at {{area}}").
  areas: {
    menu: 'the menu',
    hours: 'the opening hours',
    order_settings: 'the order settings',
    my_info: 'your restaurant info',
    marketing: 'marketing',
    reports: 'the reports',
  },
};
